import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Signup() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(null);
    const { setUser } = useAuth();
    const nav = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            const { data } = await api.post("/auth/register", { name, email, password });
            if (data.user?.status === "active") {
                // first user = admin auto-active and logged in
                setUser(data.user);
                nav("/admin", { replace: true });
            } else {
                setDone(data);
            }
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    if (done) {
        return (
            <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="signup-success">
                <div className="w-full max-w-md op-card p-8 op-fade-up">
                    <div className="op-label text-t2bb6ff">// REGISTRAZIONE RICEVUTA</div>
                    <h1 className="op-heading text-4xl mt-3">Sei in lista</h1>
                    <p className="text-tc9ccd3 mt-4 leading-relaxed">
                        Il tuo account è stato creato ma è in attesa di approvazione da parte di un
                        admin del CDP.
                    </p>
                    <p className="text-t8f95a3 mt-3 text-sm">
                        Riceverai accesso al sito non appena un amministratore ti approverà
                        manualmente e ti assegnerà una squadra (se presidente).
                    </p>
                    <Link to="/" className="op-btn op-btn-primary mt-6 inline-flex" data-testid="signup-success-home-link">
                        Torna alla home
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="signup-page">
            <div className="w-full max-w-md op-card p-8 op-fade-up">
                <div className="op-label text-t2bb6ff">// REGISTRAZIONE</div>
                <h1 className="op-heading text-4xl mt-3">Entra in OP</h1>
                <p className="text-t8f95a3 mt-2 text-sm">
                    Crea il tuo account. Dopo la registrazione un admin dovrà approvarti
                    manualmente.
                </p>

                <form className="mt-7 space-y-4" onSubmit={onSubmit}>
                    <div>
                        <label className="op-label block mb-2">Nome (o nick)</label>
                        <input
                            required
                            minLength={2}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="op-input"
                            placeholder="Mister Cioni"
                            data-testid="signup-name-input"
                        />
                    </div>
                    <div>
                        <label className="op-label block mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="op-input"
                            placeholder="presidente@example.com"
                            data-testid="signup-email-input"
                        />
                    </div>
                    <div>
                        <label className="op-label block mb-2">Password</label>
                        <input
                            type="password"
                            required
                            minLength={6}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="op-input"
                            placeholder="Almeno 6 caratteri"
                            data-testid="signup-password-input"
                        />
                    </div>
                    {err && (
                        <div
                            className="border border-tff3b30 bg-tff3b30/10 text-tff3b30 text-sm p-3"
                            data-testid="signup-error"
                        >
                            {err}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={busy}
                        className="op-btn op-btn-primary w-full"
                        data-testid="signup-submit-btn"
                    >
                        {busy ? "Registrazione in corso…" : "Registrati"}
                    </button>
                </form>

                <div className="mt-6 text-center text-sm text-t8f95a3">
                    Hai già un account?{" "}
                    <Link to="/login" className="text-t2bb6ff hover:underline" data-testid="signup-to-login">
                        Accedi
                    </Link>
                </div>
            </div>
        </div>
    );
}
